module.exports = __webpack_public_path__ + "static/media/user_second.453d99d9.svg";